<template>
  <v-container
    id="dashboard"
    fluid
    tag="section"
  >
    <!--      Check Availability-->
    <v-row
      class="px-sm-5 px-md-7 px-lg-10 elevation-4"
    >
      <v-col
        cols="12"
        sm="6"
      >
        <v-card
          flat
          class="pa-2"
        >
          <span
            class="start-header"
          >
            Start here to check availability
          </span>
          <v-form>
            <v-row>
              <v-col
                cols="12"
              >
                <GmapAutocomplete
                  class="search-location"
                  @place_changed="onPlaceChanged"
                >
                </GmapAutocomplete>
              </v-col>
              <v-col>
                <v-btn
                  color="success"
                  style="font-size: 1.15em"
                  x-large
                  to="/plans"
                >
                  SEE PLANS!
                  <v-icon
                    class="pl-3"
                  >
                    mdi-arrow-right-bold
                  </v-icon>
                </v-btn>
              </v-col>
            </v-row>
          </v-form>
        </v-card>
      </v-col>
      <v-col
        cols="12"
        sm="6"
      >
        <v-card
          flat
        >
          <v-img
            contain
            max-height="350px"
            src="../../assets/gps-locate-me.jpg"
          >
          </v-img>
        </v-card>
      </v-col>
    </v-row>
    <!--      Expect More-->
    <v-row
      class="px-sm-5 px-md-7 px-lg-10"
    >
      <v-col
        cols="12"
        md="6"
      >
        <v-card
          flat
        >
          <v-img
            contain
            max-height="270px"
            src="../../assets/wifi-network-in-home.jpg"
          >
          </v-img>
        </v-card>
      </v-col>
      <v-col
        cols="12"
        md="6"
      >
        <v-card
          flat
        >
          <p class="section-header">
            Expect More with ezWave
          </p>
          <p class="section-text">
            Setting up your own home WiFi network can be costly and result in frustrating performance.
          </p>
          <p class="section-text">
            Save money and get the best internet experience with ezWave's 'No Worries' guarantee.
            Our experts will personalize a modern WiFi network for your entire home.
            Get full bars coverage on every device in every room.
          </p>
        </v-card>
      </v-col>
    </v-row>
    <!--      Get More-->
    <v-row
      class="px-sm-5 px-md-7 px-lg-10 elevation-4"
    >
      <v-col
        cols="12"
        sm="6"
      >
        <v-card
          flat
        >
          <span class="section-header">Get More with ezWave</span>
          <v-list>
            <v-list-item
              v-for="(item, i) in itemsGetMore"
              :key="i"
              class="my-n4"
            >
              <v-list-item-icon class="mr-2">
                <v-icon
                  large
                  color="green"
                >
                  mdi-check
                </v-icon>
              </v-list-item-icon>
              <v-list-item-title>
                <span class="section-bullets">{{ item }}</span>
              </v-list-item-title>
            </v-list-item>
          </v-list>
        </v-card>
      </v-col>
      <v-col
        cols="12"
        sm="6"
      >
        <v-card
          flat
        >
          <v-img
            contain
            max-height="350px"
            src="../../assets/blog-internet-speed.png"
          >
          </v-img>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex'
  import { PUBLIC_PROCESS_GOOGLE_PLACE } from '../../store/actions.types'

  export default {
    name: 'PublicHome',
    components: {
    },
    data () {
      return {
        itemsGetMore: [
          'Video and music streaming',
          'Video conferencing & Zoom',
          'Working from home & VPNs',
          'Distance learning & Online school',
          'Playstation, Xbox, PC, etc...',
          'IoT: Alexa, Ring, Nest, SmartTVs',
          'Cloud storage & Backups',
        ],
      }
    },
    computed: {
      ...mapGetters(['publicLocation', 'isDebugMode']),
    },
    async created () {
      console.log(`Debug Mode: ${this.isDebugMode}`)
    },
    methods: {
      ...mapActions({
        processPlaceChanged: PUBLIC_PROCESS_GOOGLE_PLACE,
      }),
      async onPlaceChanged (addressData) {
        // eslint-disable-next-line camelcase
        console.log('Place Changed', addressData)
        await this.processPlaceChanged(addressData)
      },
    },
  }
</script>
